import {
	VBadge,
	VBtn,
	VIcon,
	VTooltip
} from "vuetify/lib";

export default {
	name: "KToolbarActions",

	computed: {
		actions() {
			return this.$store.state.toolbarActions.items;
		},

		sortedActions() {
			return this.actions.slice( 0 ).reverse();
		},

		genLayout() {
			return this.sortedActions.map( action => {
				const content = [
					<VIcon
						class={this.$vuetify.breakpoint.mdAndUp && "mr-2"}
					>{action.icon}</VIcon>,
					this.$vuetify.breakpoint.mdAndUp && action.text
				];
				const buttonEl = listeners =>
					<VBtn
						height="100%"
						key={`${action.text}-button`}
						minWidth={this.$vuetify.breakpoint.mdAndUp ? null : 48}
						on={listeners}
						onClick={() => ( action.onClick ? action.onClick() : null )}
						text
						tile
						to={action.to || null}
						width={this.$vuetify.breakpoint.mdAndUp ? null : 48}
					>
						{action.badge
							? <VBadge
								left
								color="error"
								overlap
							>
								<template slot="badge">{action.badge}</template>
								{content}
							</VBadge>
							: content
						}
					</VBtn>;

				if ( action.tooltip || this.$vuetify.breakpoint.smAndDown ) {
					return <VTooltip
						bottom
						key={`${action.text}-${action.tooltip ? action.tooltip : action.text}`}
						scopedSlots={{ activator: ( { on } ) => buttonEl( on ) }}
					>
						{action.tooltip || action.text}
					</VTooltip>;
				}

				return buttonEl();
			} );
		}
	},

	render() {
		if ( !this.actions.length ) {
			return;
		}

		return <div style="height: inherit;">
			{this.genLayout}
		</div>;
	}
};
